export const RequestStatus = {
  /** @type {RequestStatus} No request in flight. Ready to send one. */
  PENDING: 'PENDING',
  /** @type {RequestStatus} Actively sending a request and awaiting a response. */
  IS_FETCHING: 'IS_FETCHING',
  /** @type {RequestStatus} Received a successful response with content. */
  SUCCESS: 'SUCCESS',
  /** @type {RequestStatus} Received a successful, but empty, response. */
  NO_RESULTS: 'NO_RESULTS',
  /** @type {RequestStatus} Received an error response. */
  ERROR: 'ERROR',
};

/**
 * @typedef {String} RequestStatus
 */



// WEBPACK FOOTER //
// ./src/js/core-utilities/enums/RequestStatus.js